import { UserDetail as UserDetailComponent } from './UserDetail.component';
import { connector } from './UserDetail.connector';

export const UserDetail = connector(UserDetailComponent);
